import React, { useState, useEffect } from 'react';
import styled, { useTheme } from 'styled-components';
import { soundManager } from '../utils/sounds';

const MuteButton = styled.button`
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(15px);
  border: 2px solid rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 1.4rem;
  color: ${({ theme }) => theme.text};
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  line-height: 1;
  box-sizing: border-box;
  margin: 0;
  
  &:hover {
    transform: scale(1.06);
    background: rgba(255, 255, 255, 0.25);
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
  }
  
  &:active {
    transform: scale(0.96);
  }
  
  @media (max-width: 768px) {
    width: 40px;
    height: 40px;
    font-size: 1.2rem;
  }
`;

const MuteToggle = () => {
  const [isMuted, setIsMuted] = useState(!soundManager.enabled);
  const theme = useTheme();

  const toggleMute = () => {
    const newMutedState = !isMuted;
    setIsMuted(newMutedState);
    soundManager.setEnabled(!newMutedState);
    
    // Save mute preference to localStorage
    localStorage.setItem('gameSoundsEnabled', (!newMutedState).toString());
  };

  // Load mute preference from localStorage on component mount
  useEffect(() => {
    const savedSoundPreference = localStorage.getItem('gameSoundsEnabled');
    if (savedSoundPreference !== null) {
      const soundsEnabled = savedSoundPreference === 'true';
      setIsMuted(!soundsEnabled);
      soundManager.setEnabled(soundsEnabled);
    }
  }, []);

  return (
    <MuteButton onClick={toggleMute} theme={theme}>
      {isMuted ? '🔇' : '🔊'}
    </MuteButton>
  );
};

export default MuteToggle;